import glamorous from 'glamorous'

export const StyledForm = glamorous.form({
  paddingTop: 30,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/components/Form/Form.glamorous.tsx